import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { ReactElement, useEffect } from 'react';
import { SwiperOptions } from 'swiper/types';
import { ContentCarousel } from '@core/journeys/ui/ContentCarousel';
import { useAlgoliaStrategies } from '../../../../libs/algolia/useAlgoliaStrategies';
import { ResourceCard } from '../ResourceCard';
export interface ResourceSectionProps {
  handleItemSearch: (index: number, value: boolean) => void;
  index: number;
}
export function ResourceSection({
  handleItemSearch,
  index
}: ResourceSectionProps): ReactElement {
  const {
    breakpoints
  } = useTheme();
  const {
    label,
    hits: items
  } = useAlgoliaStrategies();
  useEffect(() => {
    handleItemSearch(index, items.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);
  const swiperBreakpoints: SwiperOptions['breakpoints'] = {
    [breakpoints.values.xs]: {
      slidesPerGroup: 2,
      spaceBetween: 4
    },
    [breakpoints.values.sm]: {
      slidesPerGroup: 3,
      spaceBetween: 4
    },
    [breakpoints.values.md]: {
      slidesPerGroup: 4,
      spaceBetween: 32
    },
    [breakpoints.values.lg]: {
      slidesPerGroup: 5,
      spaceBetween: 32
    },
    [breakpoints.values.xl]: {
      slidesPerGroup: 6,
      spaceBetween: 44
    },
    [breakpoints.values.xxl]: {
      slidesPerGroup: 7,
      spaceBetween: 44
    }
  };
  return <>
      {items.length > 0 ? <Box data-testid="ResourceSection">
          <Typography variant="h5">{label}</Typography>
          {/* ml offsets the card padding, so the card image aligns with the heading */}
          <Box sx={{
        ml: -2
      }}>
            <ContentCarousel items={items} renderItem={itemProps => <ResourceCard {...itemProps} />} breakpoints={swiperBreakpoints} content="strategies-section" />
          </Box>
        </Box> : <></>}
    </>;
}